import { render, staticRenderFns } from "./DietStays.vue?vue&type=template&id=52b73986"
import script from "./DietStays.vue?vue&type=script&lang=js"
export * from "./DietStays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports